<template>
  <v-combobox
    multiple
    v-model="profile.technicalCompetencies"
    label="Technical Competencies"
    :items="technicalCompetencies"
    @blur="submit"
    :loading="loading"
    :menu-props="{ maxHeight: '200px', offsetY: true }"
    :color="themes.candidate.light.input"
    hint="These are skills you are able to employ during the course of your day."
    attach
  >
    <template slot="selection" slot-scope="{ item, selected, parent }">
      <v-chip
        @input="parent.onChipInput"
        :key="`technical-competency-${item}`"
        :color="themes.candidate.light.chip"
        :selected="selected"
      >
        {{ item }}
        <v-icon right :color="themes.candidate.light.cancel" @click="parent.selectItem(item)">
          mdi-close-circle
        </v-icon>
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
// Data
import technicalCompetencies from '@/data/technical_competencies'

// Vue Component
export default {
  props: {
    value: Array,
    technicalCompetencies: { type: Array, default: () => technicalCompetencies },
  },
  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        technicalCompetencies: this.value || [],
      },
    }
  },
  methods: {
    submit() {
      if (this.value !== this.profile.technicalCompetencies) {
        this.loading = true
        this.$store
          .dispatch('candidate/profile/update', this.profile)
          .finally(() => (this.loading = false))
      }
    },
  },
}
</script>
